import React, { useState } from "react";
import {
  Box,
  Button,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text,
  VStack,
  useBreakpointValue,
  useToast,
} from "@chakra-ui/react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import axiosInstance from "../../config/axiosInstance";

const Forgot = () => {
  const [phone, setPhone] = useState("");
  const toast = useToast();
  const navigate = useNavigate();
  const boxWidth = useBreakpointValue({ base: "90%", sm: "xs", md: "md" });

  const handleReset = async () => {
    try {
      // ✅ Send phone instead of email
      await axiosInstance.post("/api/auth/forgot-password", { phone });

      toast({
        title: "OTP Sent",
        description: "Check your phone for the OTP.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      // ✅ Store phone in localStorage for next step
      localStorage.setItem("resetPhone", phone);
      navigate("/confirm");
    } catch (error) {
      toast({
        title: "Error",
        description: error.response?.data?.message || "Something went wrong.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Flex
      minH="100vh"
      bg="gray.50"
      justify="center"
      align="start"
      pt={16}
      px={2}
    >
      <Box
        bg="white"
        w={boxWidth}
        rounded="md"
        p={{ base: 5, md: 8 }}
        boxShadow="md"
      >
        <VStack spacing={4} align="stretch">
          <Heading fontSize={{ base: "xl", md: "2xl" }} textAlign="center">
            Password Reset
          </Heading>

          <Text fontSize="sm" textAlign="center" color="gray.600">
            Enter your phone number to reset your password
          </Text>

          <FormControl>
            <FormLabel fontSize="sm">Phone Number</FormLabel>
            <Input
              placeholder="Enter phone number"
              size="sm"
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </FormControl>

          <Button
            size="sm"
            color="white"
            bg="#005738"
            _hover={{ bg: "#00462e" }}
            w="full"
            onClick={handleReset}
            isDisabled={!phone}
          >
            Send OTP
          </Button>

          <Divider />

          <Text fontSize="xs" textAlign="center" color="gray.600">
            Remembered your password?
          </Text>

          <Button
            as={RouterLink}
            to="/login"
            size="sm"
            variant="outline"
            w="full"
            fontWeight="normal"
          >
            Back to Sign In
          </Button>
        </VStack>
      </Box>
    </Flex>
  );
};

export default Forgot;
